import React from 'react';
import {Stack} from '@mui/material';
import {
  Body,
  Button,
  designSystemToken,
  Headline,
  Modal,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

export enum DeleteAssetsModalReason {
  Cancel = 'cancel',
  Delete = 'delete',
}

interface DeleteAssetsModalProps {
  open: boolean;
  title: string;
  description: string;
  onClose: (reason: DeleteAssetsModalReason) => void;
}

function DeleteAssetsModal({
  open,
  title,
  description,
  onClose,
}: DeleteAssetsModalProps) {
  return (
    <Modal
      open={open}
      handleClose={() => onClose(DeleteAssetsModalReason.Cancel)}
      size="large"
    >
      <Stack direction="column" gap="16px">
        <Headline size="md" color={designSystemToken('semantic.fg.primary')}>
          {title}
        </Headline>
        <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
          {description}
        </Body>
        <Stack
          direction="row"
          gap="8px"
          justifyContent="center"
          marginTop="16px"
        >
          <Button
            appearance="neutral"
            mode="tinted"
            size="large"
            onClick={() => onClose(DeleteAssetsModalReason.Cancel)}
          >
            {translate('Cancel')}
          </Button>
          <Button
            appearance="neutral"
            mode="filled"
            size="large"
            onClick={async () => {
              onClose(DeleteAssetsModalReason.Delete);
            }}
          >
            {translate('Delete')}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}

export default DeleteAssetsModal;
